
export const API_URL = 'https://api.memberforaday.com/api';
export const FILE_UPLOADS = 'https://api.memberforaday.com/uploads';


// http://api.m4ad.net/api
// http://localhost:8000/api
